var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Icon from "./Icon";
import usePortal from "../hooks/usePortal";
import { transparentize } from 'polished';
import React from 'react';
import { createPortal } from 'react-dom';
import { flexbox, layout } from 'styled-system';
import { css, mq, styled, uiAssets } from "../utils";
var Overlay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  position: fixed;\n  overflow-y: auto;\n  z-index: 9999;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: center;\n  position: fixed;\n  overflow-y: auto;\n  z-index: 9999;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n\n  align-items: center;\n"])));
var Container = styled.div(function (_a) {
    var colors = _a.theme.colors, borderRadius = _a.borderRadius, maxHeight = _a.maxHeight, maxWidth = _a.maxWidth;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    position: relative;\n    background-color: ", ";\n    box-shadow: 0 2px 4px 0 ", ";\n\n    ", ";\n  "], ["\n    display: flex;\n    position: relative;\n    background-color: ", ";\n    box-shadow: 0 2px 4px 0 ", ";\n\n    ", ";\n  "])), colors.white, transparentize(0.85, colors.black), mq({
        borderRadius: borderRadius,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
    }));
}, layout);
var CloseIcon = styled(Icon.Close)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 1.5rem;\n  height: 1.5rem;\n  position: absolute;\n  cursor: pointer;\n  z-index: 9;\n\n  ", ";\n"], ["\n  width: 1.5rem;\n  height: 1.5rem;\n  position: absolute;\n  cursor: pointer;\n  z-index: 9;\n\n  ", ";\n"])), mq({
    top: ['20px', '30px'],
    right: ['20px', '30px'],
}));
var Flowers = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  top: -70px;\n  left: 50%;\n  z-index: 1;\n\n  ", ";\n"], ["\n  position: absolute;\n  top: -70px;\n  left: 50%;\n  z-index: 1;\n\n  ", ";\n"])), mq({
    width: ['150px', '200px'],
    height: ['100px', '150px'],
    margin: ['0 -75px', '0 -100px'],
    display: ['none', 'block'],
}));
var Background = styled.img(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  right: -1px;\n  top: 0;\n\n  ", ";\n"], ["\n  position: absolute;\n  right: -1px;\n  top: 0;\n\n  ", ";\n"])), mq({
    borderRadius: ['0', '5px'],
    width: ['220px', 'auto'],
    height: ['120px', 'auto'],
}));
var Content = styled.div(function (_a) {
    var components = _a.theme.components, withFlowers = _a.withFlowers;
    return mq({
        zIndex: 1,
        padding: components.modal.padding,
        marginTop: [0, withFlowers ? '4rem' : 0],
    });
}, layout, flexbox);
var Modal = function (_a) {
    var withFlowers = _a.withFlowers, withBackground = _a.withBackground, children = _a.children, onClose = _a.onClose, height = _a.height, width = _a.width, borderRadius = _a.borderRadius, props = __rest(_a, ["withFlowers", "withBackground", "children", "onClose", "height", "width", "borderRadius"]);
    var target = usePortal();
    return createPortal(React.createElement(Overlay, null,
        React.createElement(Container, { width: width, height: height, borderRadius: borderRadius, maxWidth: props.maxWidth, maxHeight: props.maxHeight },
            onClose && React.createElement(CloseIcon, { className: "close_x", onClick: onClose }),
            withFlowers && React.createElement(Flowers, { src: uiAssets('Modal/img_modal_flower.png'), alt: "flowers" }),
            withBackground && React.createElement(Background, { src: uiAssets('Modal/background.svg'), alt: "background" }),
            React.createElement(Content, __assign({ withFlowers: withFlowers }, props), children))), target);
};
Modal.defaultProps = {
    withFlowers: false,
    withBackground: false,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    width: ['100%', 650, 800, 900],
    height: ['100%', 650, 700],
    borderRadius: ['0', '5px'],
    maxHeight: ['100%', '80%'],
    maxWidth: ['100%', '90%'],
};
export default Modal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Modal.js.map